import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import RecruitHeader from '../../src/component/pc/recruit/header';
import RecruitFooter from '../../src/component/pc/recruit/footer';

// 제작
import CultureProducer from '../../src/component/pc/recruit/job/cultureProducer';
import VarietyProducer from '../../src/component/pc/recruit/job/varietyProducer';
import RadioProducer from '../../src/component/pc/recruit/job/radioProducer';

// 보도
import Journalist from '../../src/component/pc/recruit/job/journalist';

// 아나운서
import Announcer from '../../src/component/pc/recruit/job/announcer';

// 콘덴츠기획/편성
import ContentPlanning from '../../src/component/pc/recruit/job/contentPlanning';
import ContentProgramming from '../../src/component/pc/recruit/job/contentProgramming';

// 경영
import StrategicPlanning from '../../src/component/pc/recruit/job/strategicPlanning';
import AdMarketing from '../../src/component/pc/recruit/job/adMarketing';
import MediaBusiness from '../../src/component/pc/recruit/job/mediaBusiness';
import HumanResource from '../../src/component/pc/recruit/job/humanResource';
import Finance from '../../src/component/pc/recruit/job/finance';
import ManagementIT from '../../src/component/pc/recruit/job/ManagementIT';

// 
import Plan from '../../src/component/pc/recruit/job/Plan';

// 미디어엔지니어
import TechnicalPlanning from '../../src/component/pc/recruit/job/technicalPlanning';
import ContentMastering from '../../src/component/pc/recruit/job/contentMastering';
import IT from '../../src/component/pc/recruit/job/it';
import ResearchDevelopment from '../../src/component/pc/recruit/job/researchDevelopment';

function Job() {

    const [changeTab, setChangeTab] = useState(1); // tab navi

    const pageTitle = {
        1: '제작 시사교양PD : 채용 : SBS',
        2: '제작 예능PD : 채용 : SBS',
        3: '제작 라디오PD : 채용 : SBS',
        4: '보도 취재기자 : 채용 : SBS',
        5: '아나운서 : 채용 : SBS',
        6: '콘텐츠전략 콘텐츠기획 : 채용 : SBS',
        // 7: '콘텐츠전략 콘텐츠편성 : 채용 : SBS',
        8: '경영 전략 : 채용 : SBS',
        9: '경영 광고마케팅 : 채용 : SBS',
        10: '경영 IP사업 : 채용 : SBS',
        11: '경영 인사 : 채용 : SBS',
        12: '경영 재무 : 채용 : SBS',
        17: '경영 IT : 채용 : SBS',
        13: '미디어엔지니어 기술기획팀 : 채용 : SBS',
        14: '미디어엔지니어 콘텐츠마스터링 : 채용 : SBS',
        15: '미디어엔지니어 IT : 채용 : SBS',
        16: '미디어엔지니어 R&D : 채용 : SBS',
        17: '경영IT : 채용 : SBS',
        18: '기획 : 채용 : SBS',
    }

    useEffect(() => {
    }, [changeTab])

    var conClassStyle = {
        backgroundImage: "url(https://dymstorage.saramin.co.kr/neodymfiles/download_security.php?file=phpYbjwSd&path=/mgr/template/image/994)"
    };

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="description" content="" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <title>{pageTitle[changeTab]}</title>
                <link href="//image.sbs.co.kr/sbspay/sbs_pay2022/img/favicon.ico" type="image/x-icon" rel="shortcut icon" />
                <link rel="stylesheet" href="//image.sbs.co.kr/sbs_recruit/css/sbs_recruit.css" />
                <link media="screen" type="text/css" rel="stylesheet" href="https://recruit.sbs.co.kr:994/common/css/reset.css" />
                <link media="screen" type="text/css" rel="stylesheet" href="https://recruit.sbs.co.kr:994/common/css/default.css" />
                <link media="screen" type="text/css" rel="stylesheet" href="https://recruit.sbs.co.kr:994/common/css/common.css" />
                <link media="screen" type="text/css" rel="stylesheet" href="https://recruit.sbs.co.kr:994/common/css/front_error.css" />
                <link media="screen" type="text/css" rel="stylesheet" href="https://recruit.sbs.co.kr:994/common/css/jquery-modal-0.9.1.min.css" />
                <link media="screen" type="text/css" rel="stylesheet" href="https://recruit.sbs.co.kr:994/common/css/contents.css" />
            </Head>
            <div id="wrap">
                <RecruitHeader />
                {/* <!-- 직무 소개 --> */}
                <div className="basic">
                    <div className="sKeyvisual textHidden basic">
                        {/* style={{height:'40px'} */}
                        <div className="con" style={conClassStyle}></div>
                    </div>
                    {/* <!-- 공지사항 --> */}
                    <div className="mNotice">
                        <div className="clearfix">
                            <h3 className="mTitle1">직무 안내</h3>
                        </div>
                        {/* <div className="" style="text-align:center;min-height:300px;" id="contentsDiv"> */}
                        <div>
                            <div className="sbs_recruit_w">
                                <div id="recruitTabmenu">
                                    <ul className="recruit_tabmenu_w">
                                        <li className="recruit_tabmenu_inner tabmenu_type1">
                                            <h4 className="recruit_tabmenu_title">제작</h4>
                                            <div className="recruit_submenu_w">
                                                <div className={`recruit_submenu_inner ${changeTab === 1 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(1)}>시사교양PD</a>
                                                </div>
                                                {/* <div className={`recruit_submenu_inner ${changeTab === 2 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(2)}>예능PD</a>
                                                </div> */}
                                                <div className={`recruit_submenu_inner ${changeTab === 3 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(3)}>라디오PD</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="recruit_tabmenu_inner tabmenu_type2">
                                            <h4 className="recruit_tabmenu_title">보도</h4>
                                            <div className="recruit_submenu_w">
                                                <div className={`recruit_submenu_inner ${changeTab === 4 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(4)}>취재기자</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="recruit_tabmenu_inner tabmenu_type3">
                                            <h4 className="recruit_tabmenu_title">아나운서</h4>
                                            <div className="recruit_submenu_w">
                                                <div className={`recruit_submenu_inner ${changeTab === 5 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(5)}>아나운서</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="recruit_tabmenu_inner tabmenu_type4">
                                            <h4 className="recruit_tabmenu_title">편성</h4>
                                            <div className="recruit_submenu_w">
                                                <div className={`recruit_submenu_inner ${changeTab === 6 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(6)}>콘텐츠전략</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 7 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(7)}>편성</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="recruit_tabmenu_inner tabmenu_type5">
                                            <h4 className="recruit_tabmenu_title">경영</h4>
                                            <div className="recruit_submenu_w">
                                                <div className={`recruit_submenu_inner ${changeTab === 8 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(8)}>전략</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 9 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(9)}>광고마케팅</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 10 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(10)}>IP 사업</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 18 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(18)}>기획</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 11 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(11)}>인사</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 12 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(12)}>재무</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 17 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(17)}>경영IT</a>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="recruit_tabmenu_inner tabmenu_type6">
                                            <h4 className="recruit_tabmenu_title">미디어엔지니어</h4>
                                            <div className="recruit_submenu_w">
                                                <div className={`recruit_submenu_inner ${changeTab === 13 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(13)}>기술기획팀</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 14 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(14)}>콘텐츠제작기술</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 15 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(15)}>미디어IT</a>
                                                </div>
                                                <div className={`recruit_submenu_inner ${changeTab === 16 ? 'current' : ''}`} >
                                                    <a className="recruit_submenu_link" href='#none' onClick={() => setChangeTab(16)}>R&D</a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className="recruit_contents_w">
                                    {
                                        changeTab === 1 ? <CultureProducer /> : <></>
                                    }

                                    {
                                        changeTab === 2 ? <VarietyProducer /> : <></>
                                    }

                                    {
                                        changeTab === 3 ? <RadioProducer /> : <></>
                                    }

                                    {
                                        changeTab === 4 ? <Journalist /> : <></>
                                    }

                                    {
                                        changeTab === 5 ? <Announcer /> : <></>
                                    }

                                    {
                                        changeTab === 6 ? <ContentPlanning /> : <></>
                                    }

                                    {
                                        changeTab === 7 ? <ContentProgramming /> : <></>
                                    }

                                    {
                                        changeTab === 8 ? <StrategicPlanning /> : <></>
                                    }

                                    {
                                        changeTab === 9 ? <AdMarketing /> : <></>
                                    }

                                    {
                                        changeTab === 10 ? <MediaBusiness /> : <></>
                                    }

                                    {
                                        changeTab === 11 ? <HumanResource /> : <></>
                                    }

                                    {
                                        changeTab === 12 ? <Finance /> : <></>
                                    }

                                    {
                                        changeTab === 17 ? <ManagementIT /> : <></>
                                    }

                                    {
                                        changeTab === 13 ? <TechnicalPlanning /> : <></>
                                    }

                                    {
                                        changeTab === 14 ? <ContentMastering /> : <></>
                                    }

                                    {
                                        changeTab === 15 ? <IT /> : <></>
                                    }

                                    {
                                        changeTab === 16 ? <ResearchDevelopment /> : <></>
                                    }

                                    {
                                        changeTab === 18 ? <Plan /> : <></>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <RecruitFooter />
            </div>
        </>
    );
}

export default Job;